/** 
 * !!! DO NOT MODIFY !!!
 * 
 * File generated from types definition in project https://forge.cadoles.com/EFS/sheila.
 *
 * See misc/script/generate-type-defs.sh script for more informations.
 **/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HLAEngineVariableType = void 0;
var HLAEngineVariableType;
(function (HLAEngineVariableType) {
    HLAEngineVariableType["Text"] = "text";
    HLAEngineVariableType["Number"] = "number";
    HLAEngineVariableType["Boolean"] = "boolean";
})(HLAEngineVariableType || (exports.HLAEngineVariableType = HLAEngineVariableType = {}));
